import { userAgent } from '@seiue/ua';
import { noop } from '@seiue/util';
import { useEffect, useState } from 'react';
/**
 * 针对不同的浏览器，对全屏弹窗高度做适配
 *
 * @returns height
 */
export const useFullModalHeight = (fullScreen) => {
    const [height, setHeightOrigin] = useState('100vh');
    /*
     * 因为某些平板顶部栏的高度的上下变动，导致设置为 100vh 的容器在某些时候会无法显示底部内容
     * 因此，这里根据窗口的动态高度来设置容器的高度
     */
    useEffect(() => {
        if (!fullScreen)
            return noop;
        const setHeight = () => {
            const { innerHeight } = window;
            setHeightOrigin(`${innerHeight}px`);
        };
        if ((userAgent.isSafari &&
            // 由于 iPad Safari 在打开「请求桌面网址」后，其 userAgent 会变成 Mac Safari，因此这里只能对所有苹果 safari 都进行 Hack
            userAgent.isAppleDevice) ||
            // 适配安卓平板
            userAgent.isTablet) {
            window.addEventListener('resize', setHeight);
            window.addEventListener('orientationchange', setHeight);
            requestAnimationFrame(setHeight);
        }
        return () => {
            window.removeEventListener('resize', setHeight);
            window.removeEventListener('orientationchange', setHeight);
        };
    }, [fullScreen]);
    return height;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLWZ1bGwtbW9kYWwtaGVpZ2h0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL01vZGFsL3VzZS1mdWxsLW1vZGFsLWhlaWdodC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sV0FBVyxDQUFBO0FBQ3JDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxhQUFhLENBQUE7QUFDbEMsT0FBTyxFQUFFLFNBQVMsRUFBRSxRQUFRLEVBQUUsTUFBTSxPQUFPLENBQUE7QUFFM0M7Ozs7R0FJRztBQUNILE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLENBQUMsVUFBb0IsRUFBRSxFQUFFO0lBQ3pELE1BQU0sQ0FBQyxNQUFNLEVBQUUsZUFBZSxDQUFDLEdBQUcsUUFBUSxDQUFDLE9BQU8sQ0FBQyxDQUFBO0lBRW5EOzs7T0FHRztJQUNILFNBQVMsQ0FBQyxHQUFHLEVBQUU7UUFDYixJQUFJLENBQUMsVUFBVTtZQUFFLE9BQU8sSUFBSSxDQUFBO1FBRTVCLE1BQU0sU0FBUyxHQUFHLEdBQUcsRUFBRTtZQUNyQixNQUFNLEVBQUUsV0FBVyxFQUFFLEdBQUcsTUFBTSxDQUFBO1lBRTlCLGVBQWUsQ0FBQyxHQUFHLFdBQVcsSUFBSSxDQUFDLENBQUE7UUFDckMsQ0FBQyxDQUFBO1FBRUQsSUFDRSxDQUFDLFNBQVMsQ0FBQyxRQUFRO1lBQ2pCLHFGQUFxRjtZQUNyRixTQUFTLENBQUMsYUFBYSxDQUFDO1lBQzFCLFNBQVM7WUFDVCxTQUFTLENBQUMsUUFBUSxFQUNsQjtZQUNBLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxRQUFRLEVBQUUsU0FBUyxDQUFDLENBQUE7WUFFNUMsTUFBTSxDQUFDLGdCQUFnQixDQUFDLG1CQUFtQixFQUFFLFNBQVMsQ0FBQyxDQUFBO1lBRXZELHFCQUFxQixDQUFDLFNBQVMsQ0FBQyxDQUFBO1NBQ2pDO1FBRUQsT0FBTyxHQUFHLEVBQUU7WUFDVixNQUFNLENBQUMsbUJBQW1CLENBQUMsUUFBUSxFQUFFLFNBQVMsQ0FBQyxDQUFBO1lBRS9DLE1BQU0sQ0FBQyxtQkFBbUIsQ0FBQyxtQkFBbUIsRUFBRSxTQUFTLENBQUMsQ0FBQTtRQUM1RCxDQUFDLENBQUE7SUFDSCxDQUFDLEVBQUUsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFBO0lBRWhCLE9BQU8sTUFBTSxDQUFBO0FBQ2YsQ0FBQyxDQUFBIn0=